import { render, staticRenderFns } from "./ConsultationRooms.vue?vue&type=template&id=5e81370a&"
import script from "./ConsultationRooms.vue?vue&type=script&lang=js&"
export * from "./ConsultationRooms.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationRooms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports